exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-login-form-box[data-v-69b76736] {\n  width: 460px;\n  border: 1px solid #d6d6d6;\n  padding: 30px;\n  margin-top: 50px;\n  background-color: #DDEAFA;\n}\n.h-login-form-box h3[data-v-69b76736] {\n  text-align: center;\n  margin-bottom: 20px;\n}\n", ""]);

// exports
